import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, OrdemPagamentoFatura } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class OrdemPagamentoFaturaService extends BaseResourceService<OrdemPagamentoFatura> {

  constructor(
    protected injector: Injector
  ) {
    super(`ordems-pagamento-fatura`, injector);
  }
}
